import React, { useState } from 'react';
import Navbar from '../assets/navbar';
import { Navigate, Link } from "react-router-dom";
import { selectUser,login, loginUser, changeCurrentUsername } from "../reducers/userSlice"
import { useAppSelector, useAppDispatch } from '../hooks'
import loginReq from '../components/loginReq';


import {
    Flex,
    Input,
    Button,
    InputGroup,
    Stack,
    InputLeftElement,
    chakra,
    Spacer,
    Box,
    FormControl,
    InputRightElement,
    Alert,
    AlertIcon,
    Image,
    Text,
  } from "@chakra-ui/react";
import { useDispatch } from 'react-redux';


// function userlogin(){
//     const user = useAppSelector(selectUser);
//     const dispatch = useAppDispatch();
// }



function Alerts() {
  const user = useAppSelector(selectUser);
  if (user.error !== ''){
    return (
      <>
      <Alert status="error">
        {user.error}
      </Alert>
      <Link to="/forgotpassword" >
        <Text as='b'> Forgot your password? Click here</Text>
      </Link>
      </>
    )
  }
  return (
  <>

  <Link to="/forgotpassword">
    <Text as='b'> Forgot your password? Click here</Text>
  </Link>
  </>
  )

}

export default function LoginPage(){
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();
    
    const [reqDataState, setData] = useState({
        username: "",
        password: "",
      });


    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setData({ ...reqDataState});
        
        let reqData = {
          username: reqDataState.username,
          password: reqDataState.password,
        }
        let jsonReq = JSON.stringify(reqData)
        dispatch(changeCurrentUsername(reqData.username));
        dispatch(loginUser(jsonReq));
      };  

    const changeHandler = (e: { target: { name: string; value: string; }; }) => {
        if (e.target.name === "username") {
          setData({ ...reqDataState, [e.target.name]: e.target.value.trim() });
        } else {
          setData({ ...reqDataState, [e.target.name]: e.target.value });
        }
      };

      if (user.loggedIn) {
		  if (user.username == "admin") {
			  return <Navigate to="/Admin" />;
		  } else {
			  return <Navigate to="/SettingsPage" />;
		  }
      }
    return (
        <>
        <Navbar/>
        <Flex 
        flexDirection="column"
        width="100%"
        height="85vh"
        justifyContent="center"
        alignItems="center"
        marginBottom="100px"  
        >
            <Stack
            flexDir="column"
            mb="2"
            justifyContent="center"
            alignItems="center"
            >
            <Box minW={{ base: "90%", md: "200px" }}>
                <Image src="logo_nav.svg" />
            </Box>
        <Text
          marginBottom="10px"
          fontSize="30px"
          fontWeight="bold"
          color="#211a52"
        >
          Login
        </Text>
        <Box minW={{ base: "90%", md: "468px" }}>
            {/* <form onSubmit={()=>dispatch(login())}> */}
            <form onSubmit={handleSubmit}>
                <Stack
                spacing={4}
                p="1rem"
                backgroundColor="whiteAlpha.900"
                boxShadow="md"
                >
                <FormControl>
                    <InputGroup>
                    <Input mb={2}
                    type="text"
                    name="username"
                    placeholder="Username"
                    onChange={changeHandler}
                    id='username'
                  />
                    </InputGroup>
                    
                    <InputGroup>
                        <Input
                        type="password"
                        placeholder="Password"
                        name="password"
                        id="password"
                        onChange={changeHandler}
                        />
                        
                    </InputGroup>
                </FormControl>
                <Button
                
                type="submit"
                variant="solid"
                backgroundColor="#211a52"
                color="white"
                width="full"
              >
                Login
              </Button>
                </Stack>
            </form>
			{/*<Alerts/>*/}
        </Box>
            </Stack>
        </Flex>
        
        
        
        {/* <img src="logo.svg" alt="Logo"/>
        <h1>Login</h1>
        <label>Enter username 
        <input type="text" />
        </label>
        <label>Enter password 
        <input type="password" />
        </label> */}
        {/* <StoreTest/> */}
        </>
    );
}
